import "../auth/index.mjs";
import { g as p } from "../helpers-f79eaa39.mjs";
import "../validate-feature-flags-config-da9883d7.mjs";
import "../index-0b29ebb9.mjs";
import "../index-d0beacff.mjs";
function u(e, t) {
  return p(t).reduce(
    (o, r) => ({
      ...o,
      [r]: t[r][e] ?? t[r].DEFAULT
    }),
    {}
  );
}
export {
  u as getAppMarketConfig
};
